module.exports = __webpack_public_path__ + "img/hopways-03.b9841425.webp";